<template>
  <div class="favorites-section">
    <h3 class="section-title">Favorites</h3>
    <div class="favorites-list">
      <router-link 
        v-for="favorite in favorites" 
        :key="favorite.title"
        :to="favorite.path" 
        class="nav-item favorite-item" 
        active-class="active"
      >
        <span class="favorite-icon" v-html="getIconSvg(favorite.icon)"></span>
        <span class="favorite-title">{{ favorite.title }}</span>
        <button @click.prevent.stop="$emit('remove-favorite', favorite)" class="remove-favorite">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getIconSvg } from '@/utils/icons';

export default {
  name: 'FavoritesSection',
  props: {
    favorites: {
      type: Array,
      default: () => []
    }
  },
  emits: ['remove-favorite'],
  methods: {
    getIconSvg
  }
}
</script>

<style scoped>
.favorites-section {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: white;
  margin-bottom: 1rem;
  font-weight: 600;
  padding-left: 1rem;
}

.favorites-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.7rem 1rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
  font-weight: 500;
  font-size: 0.9rem;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: white;
}

.favorite-icon {
  margin-right: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.favorite-icon svg {
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.25s ease;
}

.nav-item:hover .favorite-icon svg {
  color: white;
}

.nav-item.active {
  background: rgba(79, 70, 229, 0.15);
  color: white;
  font-weight: 600;
}

.nav-item.active .favorite-icon svg {
  color: #4f46e5;
}

.favorite-title {
  flex: 1;
}

.remove-favorite {
  opacity: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.3s ease;
  color: rgba(255, 255, 255, 0.5);
}

.nav-item:hover .remove-favorite {
  opacity: 1;
}

.remove-favorite svg {
  width: 14px;
  height: 14px;
}

.remove-favorite:hover {
  color: #ef4444;
}

/* Light theme overrides */
:root[data-theme="light"] .section-title {
  color: #1f2937;
}

:root[data-theme="light"] .nav-item {
  color: rgba(0, 0, 0, 0.7);
}

:root[data-theme="light"] .favorite-icon svg {
  color: rgba(0, 0, 0, 0.5);
}

:root[data-theme="light"] .nav-item:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #000;
}

:root[data-theme="light"] .nav-item:hover .favorite-icon svg {
  color: #000;
}

:root[data-theme="light"] .nav-item.active {
  background: rgba(79, 70, 229, 0.1);
  color: #4f46e5;
}

:root[data-theme="light"] .remove-favorite {
  color: rgba(0, 0, 0, 0.4);
}
</style> 